import React from 'react'
import { withTranslation } from 'react-i18next';
import Signup from "../Signup";

const DEFAULT_CURRENCY = 'USD';

class Pricing extends React.Component{
  state = {
    currency: this.props.currency || DEFAULT_CURRENCY,
    period: 'year'
  }

  renderPrice = () => {
    const { t } = this.props;
    const {period} = this.state;
    const monthly = period === 'month';
    switch (this.state.currency) {
      case 'USD':
        return <div><span className="semibold">${ monthly ? '59' : '50' }</span><span className="inline_block font16">/{t('component.pricing.month')}*</span></div>;
      default:
        return <div><span className="semibold">{ monthly ? '59' : '50' }</span><span className="inline_block font16">€/{t('component.pricing.month')}*</span></div>;
    }
  }

  renderYearlyPrice = () => {
    const { t } = this.props;
    switch (this.state.currency) {
      case 'USD':
        return <div className="font16">${ '600' }<span className="inline_block font16">/{t('component.pricing.year')}</span></div>;
      default:
        return <div className="font16">{ '600' }<span className="inline_block font16">€/{t('component.pricing.year')}</span></div>;
    }
  }

  renderSavings = () => {
    const { t } = this.props;
      switch (this.state.currency) {
      case 'USD':
        return <div className="font16">{t('component.pricing.save')} 13%</div>;
      default:
        return <div className="font16">{t('component.pricing.save')} 15%</div>;
    }
  }

  switchPeriod = (period) => {
    this.setState({period});
  }

  changeCurrency = (currency) => {
    this.setState({currency});
  }

  render(){
  const {t, i18n} = this.props;
  const {period, currency} = this.state;

    return (<section id="pricing" className="padding_top140 padding_bottom140 component-Pricing">
        <div className="container nopadding">
      		<div className="row justify-content-center">
      			<div className="col-xl-6 col-lg-6 padding_top50">
      					<h1 className="font_second light font42 break-line">{t('component.pricing.title')}</h1>
      					<div className="max_width570 margin_auto top30 font18 light dark_blue text">
            			{t('component.pricing.subtitle')}
            		</div>
    						<div className="row top60 bottom60">
    							<div className="col-xl-10">
                    <Signup/>
    							</div>
    						</div>
      			</div>
      			<div className="col-xl-1"></div>
      			<div className="col-xl-5 col-lg-6 nopadding right_block component-Pricing__table">
              <div className="row align-items-center justify-content-center inner">
                <div className="col-lg-12">
                  <div className="component-Pricing__period-switch">
                    <button className={`semibold uppercase ${period === 'month' ? 'active' : ''}`} onClick={()=>this.switchPeriod('month')}>{t('component.pricing.monthly')}</button>
                    <button className={`semibold uppercase ${period === 'year' ? 'active' : ''}`} onClick={()=>this.switchPeriod('year')}>{t('component.pricing.yearly')}</button>
                  </div>
            			<div className="padding_top25 padding_bottom45 block radius3 bg_white padding_sides60">
            				<div className="text-center">
              				<select name="country" value={currency} className="input size50 border border_light_gray focus_blue radius6 width100 padding_sides20" onChange={(e)=>this.changeCurrency(e.target.value)}>
        						    <option value="EUR">EUR</option>
        						    <option value="USD">USD</option>
        					    </select>
      					    </div>
      					    <div className="text-center bottom40 top40 font54 light dark_gray price">
      					    {
      					      this.renderPrice()
      					    }
      					    { period ==='year' &&
      					      <div>
      					        {this.renderYearlyPrice()}
    					          <div className="font16 bg_red white padding_sides25 padding_top5 padding_bottom5 inline_block">{this.renderSavings()}</div>
      					      </div>
      					    }
            				</div>
            				<div className="height1  bg_black opacity2 bottom40"></div>
            				<div className="bottom20 item flex"><i className="fa fa-check blue right50"></i><span>{t('component.pricing.value.features.1')}</span></div>
            				<div className="bottom20 item flex"><i className="fa fa-check blue right50"></i><span>{t('component.pricing.value.features.2')}</span></div>
            				<div className="bottom20 item flex"><i className="fa fa-check blue right50"></i><span>{t('component.pricing.value.features.3')}</span></div>
            				<div className="bottom20 item flex"><i className="fa fa-check blue right50"></i><span>{t('component.pricing.value.features.4')}</span></div>
            				<div className="height1  bg_black opacity2 top40"></div>
            				<div className="opacity7 font12 bottom40">* {t('component.pricing.vat')}</div>
            			</div>
          			</div>
          		</div>
      			</div>
      		</div>
      	</div>
      </section>);
  }
}
export default withTranslation()(Pricing);
